import { Dropdown } from 'components/Dropdown/Dropdown';
import { DropdownMenu } from 'components/Dropdown/menus/Menu/DropdownMenu';
import { DropdownMenuItem } from 'components/Dropdown/menus/Menu/Item/DropdownMenuItem';
import { Icon } from 'components/Icon/Icon';
import { useI18n } from 'i18n/hooks/useI18n';
import { useRsvpAnswer } from 'modules/listing/events/hooks/useRsvpAnswer';
import { trackClicked } from 'utils/analytics/track/trackClicked';

import {
  RsvpButtonMenuItem,
  RsvpDropdownHeaderTrigger,
} from './RsvpButton.styled';

const TRIGGER_TEXT = {
  GOING: getText('Going'),
  NOT_GOING: getText('Not Going'),
  INTERESTED: getText('Interested'),
} as Record<string, string>;

type Props = {
  className?: string;
  listingId: string;
};

export function RsvpButton({ className, listingId }: Props) {
  const { i18n } = useI18n();

  const { answer, postRsvp } = useRsvpAnswer(listingId, false);
  const triggerText =
    answer && TRIGGER_TEXT[answer] ? TRIGGER_TEXT[answer] : i18n('RSVP');

  return (
    <Dropdown
      className={className}
      trigger={
        <RsvpDropdownHeaderTrigger
          variant="blue"
          minWidth={50}
          centerHorizontally
        >
          {answer && <Icon name="checkmark-filled" size={18} />}
          {triggerText}
          {!answer && <Icon name="chevron-down" size={18} />}
        </RsvpDropdownHeaderTrigger>
      }
      qaId="rsvp-dropdown"
    >
      <DropdownMenu
        width="147px"
        qaId="rsvp-dropdown-menu"
        placement="bottom-right"
        mobilePlacement="top-right"
      >
        <DropdownMenuItem>
          <RsvpButtonMenuItem
            data-qa-id="rsvp-answer-going"
            onClick={() => {
              trackClicked('RSVP user response', {
                answer: 'going',
                listing_id: listingId,
              });
              postRsvp('GOING');
            }}
          >
            {i18n('Going')}
          </RsvpButtonMenuItem>
        </DropdownMenuItem>
        <DropdownMenuItem>
          <RsvpButtonMenuItem
            data-qa-id="rsvp-answer-interested"
            onClick={() => {
              trackClicked('RSVP user response', {
                answer: 'interested',
                listing_id: listingId,
              });
              postRsvp('INTERESTED');
            }}
          >
            {i18n('Interested')}
          </RsvpButtonMenuItem>
        </DropdownMenuItem>
        <DropdownMenuItem>
          <RsvpButtonMenuItem
            data-qa-id="rsvp-answer-not-going"
            onClick={() => {
              trackClicked('RSVP user response', {
                answer: 'not_going',
                listing_id: listingId,
              });
              postRsvp('NOT_GOING');
            }}
          >
            {i18n('Not Going')}
          </RsvpButtonMenuItem>
        </DropdownMenuItem>
      </DropdownMenu>
    </Dropdown>
  );
}
